import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { BusinessRuleError, IErrorCode } from '@carm/_utils/models';
import { IMappedError } from '@carm/_utils/models';
import { TranslateService } from '@ngx-translate/core';

/**
 * Updates form group
 * @param formGroup formGroup on which errors need to map
 * @param mappedErrors Backend erroMap array
 */
export function UpdateErrorMapInFormGroup(formGroup: UntypedFormGroup, mappedErrors: IMappedError[]): boolean {

  let hasFormError = false;

  if ( mappedErrors && mappedErrors.length > 0 ) {
    Object.keys(formGroup.controls).forEach((formControlName: string) => {
      const formControl = formGroup.get(formControlName);
      if ( instanceOfFormGroup(formControl)) {
          const subFromGroup = formControl as UntypedFormGroup;
          const hasSubFormError = UpdateErrorMapInFormGroup(subFromGroup, mappedErrors );

          if (hasSubFormError) {
            hasFormError = true;
          }
       }
    });
    mappedErrors.forEach((mappedError) => {

      if (mappedError.value.errors.length > 0) {
        if (formGroup.get(mappedError.key) ) {
          formGroup.get(mappedError.key).setErrors({ code: mappedError.value.errors[0].code, message: mappedError.value.errors[0].code } as IErrorCode);
          hasFormError = true;
        }
      }
    });
  }

  return hasFormError;
}

/**
 * This method will try to get the erroMap from the obect and return the first error message
 */
export function parseErrorMessage(error: any, translateService: TranslateService): string {
  if (error instanceof BusinessRuleError) {
    return getMessageByCode(error.mappedErrorList[0].value.errors[0].code, translateService);
  } else {
    return error;
  }
}


/**
 * This method will try to get the erroMap from the obect and return the first error message
 */
export function getErrorMessageWithoutTranslation(error: any): string {
  if (error instanceof BusinessRuleError) {
    return error.mappedErrorList[0].value.errors[0].message;
  } else {
    return error;
  }
}


export function getMessageByCode(code: string, translateService: TranslateService): string {
    const ngxTranslatePrefix = 'errors.';
    return translateService.instant(ngxTranslatePrefix + code);
}

export interface FormGroupControls {
  [key: string]: AbstractControl;
}

/**
 * Gets form validation errors and return array of errors with controlname
 * @param controls
 * @returns form validation errors
 */
export function getFormValidationErrors(controls: FormGroupControls): {controlName: string, message: string }[] {
  let errors: {controlName: string, message: string }[] = [];
  Object.keys(controls).forEach((key) => {
    const control = controls[ key ];
    if (control instanceof UntypedFormGroup) {
      errors = errors.concat(getFormValidationErrors(control.controls));
    }

    if ( controls[ key ].errors ) {
      const controlError: string = controls[ key ].errors.code ? controls[ key ].errors.code : controls[ key ].errors.message;
      if ( controlError ) {
        errors.push({ controlName: key, message: controlError});
      }
    }
  });
  return errors;
}

function instanceOfFormGroup(object: any): boolean {
  return 'controls' in object;
}
